import {
  GuidId,
  ListPrimaryKeyId,
  PrimaryKeyId,
  StripeCustomerId,
} from "src/app/models";
import { isGuid } from "./guid-test.helper";

/**
 * Checks if the id is valid
 *
 * - Throws exception if invalid
 *
 * @param value
 */
export function assertUserId(
  value: number | null | undefined
): asserts value is number {
  if (!value || value < 0) throw new Error("Invalid user id");
}

/**
 * Checks if the id is valid
 *
 * - Throws exception if invalid
 *
 * @param value
 */
export function assertTenantId(
  value: number | null | undefined
): asserts value is number {
  if (!value || value < 0) throw new Error("Invalid tenant id");
}

export function assertTenantGuid(
  value: string | null | undefined
): asserts value is GuidId {
  if (!value || !isGuid(value)) throw new Error("Invalid tenant guid");
}

export function assertCustomerId(
  value: string
): asserts value is StripeCustomerId {
  if (value === "") throw new Error("Customer id not available");
}

export function assertListId(value: any): asserts value is ListPrimaryKeyId {
  const id = parseInt(value);
  if (isNaN(id) || value < 0) throw new Error("Invalid list id");
}

export function assertPrimaryKeyId(
  value: number
): asserts value is PrimaryKeyId {
  if (value < 0) throw new Error("Id not valid");
}
